import React, { useEffect, useRef, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

const authHeader = () => {
  const t = localStorage.getItem("session_token");
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { refresh } = useAuth();
  const [status, setStatus] = useState({ payment_status: "pending", credited: false });
  const [attempts, setAttempts] = useState(0);
  const timerRef = useRef(null);

  const sessionId = params.get("session_id");

  useEffect(() => {
    if (!sessionId) { nav("/store"); return; }
    let cancelled = false;
    const poll = async () => {
      try {
        const tok = localStorage.getItem("session_token");
        const headers = tok ? { Authorization: `Bearer ${tok}` } : {};
        const r = await api.get(`/payments/status/${sessionId}`, { headers });
        if (cancelled) return;
        setStatus(r.data);
        if (r.data.payment_status === "paid" && r.data.credited) {
          await refresh();
          toast.success(`+${r.data.coins} coins`);
          return;
        }
        if (attempts < 20) {
          setAttempts(a => a + 1);
          timerRef.current = setTimeout(poll, 2000);
        }
      } catch (e) {
        if (attempts < 20) {
          setAttempts(a => a + 1);
          timerRef.current = setTimeout(poll, 2000);
        }
      }
    };
    poll();
    return () => { cancelled = true; if (timerRef.current) clearTimeout(timerRef.current); };
    // eslint-disable-next-line
  }, [sessionId]);

  const paid = status.payment_status === "paid" && status.credited;

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="glass rounded-2xl p-8 max-w-md w-full text-center">
        {paid ? (
          <>
            <div className="text-6xl mb-3">🪙</div>
            <div className="text-xs uppercase tracking-[0.3em] text-white/50">Payment complete</div>
            <div className="font-display text-3xl mt-2">+{status.coins} coins</div>
            <p className="text-white/60 mt-3 text-sm">Coins added to your balance. Ready to unlock some drip.</p>
            <div className="mt-6 flex gap-3 justify-center">
              <button onClick={() => nav("/store")} className="px-5 py-2.5 rounded-full bg-[color:var(--uno-yellow)] text-black font-semibold">Back to store</button>
              <button onClick={() => nav("/lobby")} className="px-5 py-2.5 rounded-full bg-white/10 hover:bg-white/20 font-semibold">Lobby</button>
            </div>
          </>
        ) : (
          <>
            <div className="text-6xl mb-3 animate-pulse">⏳</div>
            <div className="text-xs uppercase tracking-[0.3em] text-white/50">Confirming payment</div>
            <div className="font-display text-2xl mt-2">Just a sec…</div>
            <p className="text-white/50 mt-3 text-sm">If this hangs, your card may have been declined or the session expired.</p>
          </>
        )}
      </div>
    </div>
  );
}
